import React, {Component} from "react"
import SponsoredAdCard from "./SponsoredAdCard"
import AdCard from "./AdCard"
import AdsData from "./data/AdsData"

class AddList extends Component {
	constructor () {
		super()
		this.state = {
			loading: false,
			adsData: [],
		}
	}
	componentDidMount() {
		// api request to get all ads from server
	}
	render () {
		const AdsComponent = AdsData.map((ad) => <AdCard key={ad.id} data={ad} />)
		return (
			<div className="greyBg">
				<SponsoredAdCard />
				{AdsComponent}
				<div style={{height: "30px"}}></div>
			</div>
		)
	}
}

export default AddList